/**
 * A rave that does not exist, or is not this person's to see, sends them to
 * the main app (`app.<platform>`) — the user, 2026-10-06: "if trying to access
 * a rave that does not exist or is blocked, the user should be redirected to
 * the master app". Not the bare domain, which is the holding page in
 * production; not a "not found" screen, which is a dead end.
 *
 * Mount it ONLY on the server's definitive answer (a 404, a festival with
 * nothing published). No signal is not an answer: in a field, leaving the
 * offline copy behind would throw the product away.
 */
import { useEffect } from 'react';
import { LoadingScreen } from '@/ui';
import { useT } from '@/i18n';
import { appUrl } from '@/lib/tenant';

export function ToApp() {
  const tr = useT();
  useEffect(() => { window.location.replace(appUrl('/')); }, []);
  return <LoadingScreen label={tr('Taking you to MyRave…')} />;
}
